var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_25",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 25",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.711,
    height: 17.334,
    viewBox: "0 0 18.711 17.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 7",
    d: "M42.384,55.043H37.773a.593.593,0,0,1,0-1.183h4.611a.593.593,0,0,1,0,1.183Z",
    transform: "translate(-30.207 -41.071)",
    fill: "#ff974a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8",
    d: "M47.853,52.695a.6.6,0,0,1-.42-.173l-1.061-1.065a.59.59,0,1,1,.84-.822L48.277,51.7a.59.59,0,0,1,0,.837A.6.6,0,0,1,47.853,52.695Z",
    transform: "translate(-35.379 -38.95)",
    fill: "#ff974a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 9",
    d: "M46.844,56.592a.593.593,0,0,1-.416-1.01l1.061-1.065a.6.6,0,0,1,.837,0,.59.59,0,0,1,0,.837L47.268,56.43A.59.59,0,0,1,46.844,56.592Z",
    transform: "translate(-35.432 -41.031)",
    fill: "#ff974a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 10",
    d: "M38.673,40.074H28.259a3.907,3.907,0,0,1-4.149-3.6V35.3a3.907,3.907,0,0,1,4.149-3.6H38.673a3.907,3.907,0,0,1,4.149,3.6v1.178A3.911,3.911,0,0,1,38.673,40.074ZM28.259,33.011A2.487,2.487,0,0,0,25.62,35.3v1.178a2.485,2.485,0,0,0,2.639,2.271H38.673a2.487,2.487,0,0,0,2.639-2.288V35.3a2.482,2.482,0,0,0-2.639-2.288ZM33.5,30.332a4.12,4.12,0,0,1-4.384-3.794,4.118,4.118,0,0,1,4.378-3.8,4.119,4.119,0,0,1,4.381,3.8A4.123,4.123,0,0,1,33.5,30.332Zm0-6.28a2.905,2.905,0,0,0-2.655,1.534A2.252,2.252,0,0,0,31.47,28.3a3.2,3.2,0,0,0,3.129.538,2.51,2.51,0,0,0,1.769-2.3A2.7,2.7,0,0,0,33.5,24.069Z",
    transform: "translate(-24.11 -22.74)",
    fill: "#ff974a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fac51715.svg";
export { ForwardRef as ReactComponent };